var styles = ["[_nghost-%COMP%]   p.welcome[_ngcontent-%COMP%]{width:225px;text-align:center;margin-left:auto!important;margin-right:auto!important;font-size:20px;font-weight:600;margin-bottom:30px}"];
export { styles as styles };
